import { ChangeEventHandler, useState } from 'react';
import './KParameterInput.scss';
import { InputTextCustom } from 'medere-ui-framework';

interface KParameterInputProps {
    value: string;
    onChange:ChangeEventHandler<HTMLInputElement>;
    className?: string;
}

const KParameterInput = ({ value, onChange, className }: KParameterInputProps) => {
    const [showTooltip, setShowTooltip] = useState(false);

    return (
        <div className='kparameter-input'>
            <p className="header-info">
                Ponderado
                <span
                    onMouseEnter={() => setShowTooltip(true)}
                    onMouseLeave={() => setShowTooltip(false)}
                    className="icon-info"
                >
                    i
                </span>
            </p>

            <InputTextCustom
                className={className+" border2"}
                value={value}
                onChange={onChange}
            />

            {showTooltip && (
                <div className="tooltip-box">
                    <ul className="justified-list">
                        <li>Un balance adecuado es un valor entre 20 y 30.</li>
                        <li>Si se quiere priorizar más las especialidades con pocos pacientes en atención médica usar valores entre 50 y 70.</li>
                        <li>Si se quiere priorizar más el tiempo en espera administrativa, se puede reducir a 10 o 15.</li>
                    </ul>
                </div>
            )}
        </div>
    );
};

export default KParameterInput;
